// add class in body as per os

const userAgent = navigator.userAgent.toLowerCase();
let browserName = '';

// Detect Brave first (since Brave also reports as Chrome)
if (navigator.brave && navigator.brave.isBrave) {
  navigator.brave.isBrave().then((isBrave) => {
    if (isBrave) {
      document.body.classList.add('browser-brave');
    } else {
      detectBrowser(); // fallback to others if not Brave
    }
  });
} else {
  detectBrowser();
}

function detectBrowser() {
  if (userAgent.includes('edge')) {
    browserName = 'edge';
  } else if (userAgent.includes('chrome')) {
    browserName = 'chrome';
  } else if (userAgent.includes('firefox')) {
    browserName = 'firefox';
  } else if (userAgent.includes('safari') && !userAgent.includes('chrome')) {
    browserName = 'safari';
  } else if (userAgent.includes('opr') || userAgent.includes('opera')) {
    browserName = 'opera';
  } else if (userAgent.includes('msie') || userAgent.includes('trident')) {
    browserName = 'ie';
  }

  if (browserName) {
    document.body.classList.add('browser-' + browserName);
  }
}


// os js 
document.addEventListener('DOMContentLoaded', function () {
  var ua = navigator.userAgent.toLowerCase();
  var body = document.body;

  /* OS */
  if (/android/.test(ua)) body.classList.add('os-android');
  else if (/iphone|ipod/.test(ua)) body.classList.add('os-ios');
  else if (/ipad/.test(ua) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1))
    body.classList.add('os-ipados');
  else if (/windows/.test(ua)) body.classList.add('os-windows');
  else if (/mac os/.test(ua)) body.classList.add('os-macos');

  /* Browser */
  function addBrowser() {
    if (ua.indexOf('edg') > -1) body.classList.add('browser-edge');
    else if (ua.indexOf('opr') > -1 || ua.indexOf('opera') > -1) body.classList.add('browser-opera');
    else if (ua.indexOf('chrome') > -1) body.classList.add('browser-chrome');
    else if (ua.indexOf('firefox') > -1) body.classList.add('browser-firefox');
    else if (ua.indexOf('safari') > -1 && ua.indexOf('chrome') === -1)
      body.classList.add('browser-safari');
  }

  if (navigator.brave && navigator.brave.isBrave) {
    navigator.brave.isBrave().then(function (isBrave) {
      isBrave ? body.classList.add('browser-brave') : addBrowser();
    });
  } else {
    addBrowser();
  }
});
